import { createProductExtensions } from './utils';
export { Editions } from './types';
export var editionExtensionsWhitelist = ['edition'];
export var createEditionExtensions = createProductExtensions(editionExtensionsWhitelist);